<template>
    <div>
        <div :class="classWrapper">
            <input
                type="range"
                :class="theme.inputRaw"
                :value="value"
                :min="min"
                :max="max"
                :step="step"
                @input="handleInput"
                @mousedown="handleDown"
                @mouseup="handleUp"
            />

            <div :class="theme.range">
                <div :class="theme.rangeFilled" :style="{ width: cicleOffsetLeft }"></div>
            </div>
            <div :class="classCircle" :style="{ left: cicleOffsetLeft }"></div>
        </div>

        <div :class="theme.labels">
            <div>
                <slot name="min" :min="min">
                    <v-text type="caption">
                        {{ min }}
                    </v-text>
                </slot>
            </div>
            <div>
                <slot name="max" :max="max">
                    <v-text type="caption">
                        {{ max }}
                    </v-text>
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
    import { vText } from '../Typography';
    import theme from './range.scss';

    export default {
        name: 'range',
        props: {
            readonly: Boolean,
            disabled: Boolean,
            theme: {
                type: Object,
                default() {
                    return theme
                }
            },
            value: {
                type: [String, Number],
                default: 0,
            },
            min: {
                type: Number,
                default: 0,
            },
            max: {
                type: Number,
                default: 100,
            },
            step: {
                type: Number,
                default: 1,
            }
        },
        components: {
            vText,
        },
        methods: {
            handleDown() {
                this.isActive = true;
            },
            handleUp() {
                this.isActive = false;
            },
            handleInput(e) {
                if (this.readonly || this.disabled) {
                    return;
                }

                this.$emit('input', e.target.value)
            }
        },
        computed: {
            classWrapper() {
                return {
                    [this.theme.rangeWrapper]: true,
                    [this.theme.isDisabled]: this.disabled,
                }
            },
            classCircle() {
                return {
                    [this.theme.circle]: true,
                    [this.theme.isActive]: this.isActive && !this.disabled,
                }
            },
            cicleOffsetLeft() {
                switch (true) {
                    case Number(this.value) < this.min:
                        return '0%';
                    case Number(this.value) > this.max:
                        return '100%';
                    default:
                        return Number(this.value - this.min) * 100 / (this.max - this.min) + '%';
                }
            }
        },
        data() {
            return {
                isActive: false,
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Range.vue?2588fff6